var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lm-icon-button',{staticClass:"LmSummaryComment",class:{'new-comments': _vm.newComments},attrs:{"icon":"chat_bubble_outline","label":_vm.numComments,"tooltip":_vm.tooltip},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }